<template>
  <div class="home_content_wrapper">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "SubscriptionsHome",
};
</script>

<style scoped>
.home_content_wrapper {
  width: 100%;
  min-height: 100vh;
}
</style>
